module.exports = __webpack_public_path__ + "img/procedure_klaim.4a13f329.png";